import React from 'react';
import {BrowserRouter as Router, Switch, Route} from "react-router-dom";
import Header from "./Header";
import VideoList from "./VideoList";
import VideoOverview from "./VideoOverview"
import Search from "./Search";
import ArtistOverview from "./ArtistOverview"
import Home from "./Layout/Home";
import Artists from "./Layout/Artists";
import Artist from "./Layout/Artist";

const App = () => {

    return (
        <Router>
            <Header/>
            <Route path="/" component={Home} exact/>
            <Route path="/artists" component={Artists}/>
            <Route path="/artist/:artistId" component={Artist}/>
        </Router>
    );
}

export default App;